import React from 'react'
import styles from './Price.module.css'
import VerticalTabs from './PriceTable'

const Price = () => {
  return (
    <section className={styles.price_area}>
        <h2><span>料金</span>の概算</h2>
        <div className={styles.contents}>
            <VerticalTabs />
        </div>
    </section>
  )
}

export default Price